{
  "polygon": {
    "Pixelflux": [
      "0xf8561640FA9E7EE295D9B6C4DD59FD9826374d6b",
      "0x538D71D91a9301c0231fFC643fAdB829d15B06Bd",
      "0x065cFc82218186e7113c476C23F201227639f2C4"
    ]
  }
}
